const styles = {
  footer: {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    fontSize: 11,
    justifyContent: "center"
  }
};

export default styles;
